import { useEffect, useState } from "react";
import {
  GetChild,
  GetPartner,
  GetPersonalDetails,
  GetRelationship,
  GetAllPet,
} from "../../api/get";
import { Modal } from "react-responsive-modal";
import FloatingLabelInput from "../../Common/FloatingLabel";
import FloatingLabelDropdown from "../../Common/FloatingLabelDropdown";
import { MerritalStatus, options } from "../../json/List";
import Loader from "../../loader";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa";
import { FaInfoCircle } from "react-icons/fa";
import {
  AddChild,
  AddPartner,
  AddPet,
  EditChild,
  ProfileForm,
  EditPersonalDetails,
  RemovePartner,
  EditPet,
  RemovePet,
  RemoveChild,
} from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import Header from "../../Common/Header";
import { useFormik } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import { Link, Navigate, useNavigate } from "react-router-dom";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import Spinner from "../../Common/Spinner";
import { handleApiError } from "../../Common/Helper";
const YourFamilyReview = () => {
  const [getChild, setGetChild] = useState([]);
  const [open, setOpen] = useState(false);
  const [childOpen, setChildOpen] = useState(false);
  const [petOpen, setPetOpen] = useState(false);
  const [pet, setPet] = useState([]);
  const [yourPartner, setYourPartner] = useState([]);
  const onOpenModal = () => setOpen(true);
  const [contentLoder, setContentLoader] = useState(true);
  const [YourselfData, setYourSelfData] = useState({});
  const [loading, setLoading] = useState(false);
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe("dd/mm/yyyy");
  const [isFocused, setIsFocused] = useState(false);
  const [showSecondAddress, setShowSecondAddress] = useState(false);
  const [relationship, setRelationship] = useState({});
  const [refresh, setRefresh] = useState(false); // Track changes
  const [refreshPartner, setRefreshPartner] = useState(false);
  const [refreshPet, setRefreshPet] = useState(false);
  const [refreshChild, setRefreshChild] = useState(false);
  const [partnerOpen, setPartnerOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false); // new state variable
  const [isPetEditMode, setIsPetEditMode] = useState(false);
  const [isChildEditMode, setIsChildEditMode] = useState(false);

  const onPartnerOpenModel = (editMode = false) => {
    setIsEditMode(editMode);
    setPartnerOpen(true);
  };
  const onChildCloseModal = () => {
    setChildOpen(false);
    setIsChildEditMode(false); // Reset edit mode on close
    formikChild.resetForm(); // Reset the form on modal close
  };

  const onPetCloseModal = () => {
    setPetOpen(false);
    setIsPetEditMode(false); // Reset edit mode on close
    petFormik.resetForm(); // Reset the form on modal close
  };

  const onCloseModal = () => {
    setOpen(false);
    formik.resetForm(); // Reset the form on modal close
  };
  const onPartnerCloseModel = () => {
    setPartnerOpen(false);
    formikPartner.resetForm(); // Reset the form on modal close
  };

  const navigate = useNavigate();
  const formatDateToYMD = (date) => {
    const [day, month, year] = date.split("/");
    return `${year}-${month}-${day}`;
  };
  // Helper function to format date in dd/mm/yyyy format
  const formatDate = (dateString) => {
    const date = new Date(dateString); // Create a Date object from the string
    const day = String(date.getDate()).padStart(2, "0"); // Get the day with leading zero if needed
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get the month (0-based, so add 1)
    const year = date.getFullYear(); // Get the year
    return `${day}/${month}/${year}`; // Return the formatted date
  };
  // Handle API errors uniformly
  // const handleApiError = (response) => {
  //   if (response.status_code === "501") {
  //     toast.error(response.data.error);
  //   } else if (response.status_code === "422") {
  //     const errorMessages = Object.values(response.data.error)
  //       .flat()
  //       .join(", ");
  //     toast.error(errorMessages);
  //   }
  // };

  useEffect(() => {
    // Fetch personal details and relationships and set form values once loaded
    Promise.all([GetPersonalDetails(), GetRelationship()])
      .then(([personalDetails, relationshipOptions]) => {
        if (
          personalDetails.success &&
          relationshipOptions.success &&
          personalDetails.status_code === "200" &&
          relationshipOptions.status_code === "200"
        ) {
          setYourSelfData(personalDetails.data); // Set YourselfData with the fetched details
          // formik.setValues(personalDetails.data);
          setRelationship(
            relationshipOptions.data.map((item) => ({
              value: item.id,
              label: item.name,
            }))
          );
          setContentLoader(false);
          setShowSecondAddress(true);
        } else if (!personalDetails.success) {
          handleApiError(personalDetails, navigate); // Use helper function
        } else if (!relationshipOptions.success) {
          handleApiError(relationshipOptions, navigate); // Use helper function
        }
      })
      .catch((err) => console.error("Error fetching data", err));
  }, [refresh]);
  useEffect(() => {
    GetPartner()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setYourPartner(res.data);
        } else {
          handleApiError(res,navigate);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [refreshPartner]);

  useEffect(() => {
    GetAllPet()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setPet(res.data);
        } else {
          handleApiError(res,navigate);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [refreshPet]);
  useEffect(() => {
    GetChild()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setGetChild(res.data);
        } else {
          handleApiError(res,navigate);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [refreshChild]);
  // console.log("getChild =>", getChild);

  const RemovePartnerFunction = () => {
    RemovePartner()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setYourPartner([]);
          setRefreshPartner(true);
          setPartnerOpen(false);
          toast.success("partner removed successfully");
        } else {
          handleApiError(res,navigate);
        }
      })
      .catch(() => toast.error("Failed to remove child"));
  };

  const RemovePetFunction = (pet_id) => {
    RemovePet(pet_id)
      .then((res) => {
        if (res.success && res.status_code === "200") {
          // Filter out the removed pet immediately from the state
          setPet((prevPets) => prevPets.filter((pet) => pet.id !== pet_id));
          setRefreshPet(!refreshPet); // Trigger refresh after deletion
          setPetOpen(false);
          setIsPetEditMode(false);
          petFormik.resetForm();
          toast.success("Pet Removed Successfully");
        } else {
          handleApiError(res,navigate);
        }
      })
      .catch(() => toast.error("Failed to remove child"));
  };

  const RemoveChildFunction = (child_id) => {
    RemoveChild(child_id)
      .then((res) => {
        if (res.success && res.status_code === "200") {
          // Filter out the removed pet immediately from the state
          setGetChild((prevChild) =>
            prevChild.filter((child) => child.id !== child_id)
          );
          setRefreshChild(!refresh); // Trigger refresh after deletion
          setChildOpen(false);
          setIsChildEditMode(false);
          formikChild.resetForm();
          toast.success("Child removed successfully");
        } else {
          handleApiError(res,navigate);
        }
      })
      .catch(() => toast.error("Failed to remove child"));
  };

  // Yup validation schema
  const validationSchema = Yup.object().shape({
    user_prefix: Yup.string().required("Required field"),
    first_name: Yup.string().required("Required field"),
    last_name: Yup.string().required("Required field"),
    date_of_birth: Yup.string()
      .nullable()
      .matches(
        /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
        "Date of birth must be in dd/mm/yyyy format"
      )
      .required("Required field")
      .test("is-past-date", "Date must be in the past", (value) => {
        if (!value) return true; // Skip if empty
        const [day, month, year] = value.split("/");
        const enteredDate = new Date(`${year}-${month}-${day}`);
        return enteredDate < new Date();
      })
      .test(
        "is-after-1900",
        "Please enter a date of birth after 1900",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          return parseInt(year) > 1900;
        }
      )
      .test(
        "is-over-18",
        "Sorry, but your partner needs to be over 18.",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          const enteredDate = new Date(`${year}-${month}-${day}`);
          const today = new Date();
          const age = today.getFullYear() - enteredDate.getFullYear();
          const isBirthdayPassed =
            today.getMonth() > enteredDate.getMonth() ||
            (today.getMonth() === enteredDate.getMonth() &&
              today.getDate() >= enteredDate.getDate());
          return age > 18 || (age === 18 && isBirthdayPassed);
        }
      ),
    address_line_1: Yup.string().required("Required field"),
    postcode: Yup.string().required("Required field"),
    city: Yup.string().required("Required field"),
    relationship_id: Yup.string().required("Required field"),
    phone_number: Yup.string()
      .matches(/^\d+$/, "Phone Number must be numeric")
      .min(10, "Phone Number must be at least 10 digits")
      .max(10, "Phone Number cannot exceed 10 digits"),
  });
  const formik = useFormik({
    initialValues: {
      user_prefix: YourselfData?.user_prefix || "",
      first_name: YourselfData?.first_name || "",
      last_name: YourselfData?.last_name || "",
      date_of_birth: YourselfData?.dob
        ? new Date(YourselfData.dob).toLocaleDateString("en-GB")
        : "",
      address_line_1: YourselfData?.address_line_1 || "",
      address_line_2: YourselfData?.address_line_2 || "",
      postcode: YourselfData?.postcode || "",
      city: YourselfData?.city || "",
      relationship_id: YourselfData?.relationship_id || "",
      phone_number: YourselfData?.phone_number || "",
    },
    validationSchema, // Apply validation schema
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      // Convert "date_of_birth" from "dd/mm/yyyy" to "dob" with "dd-mm-yyyy"
      const transformedValues = {
        ...values,
        dob: formatDateToYMD(values.date_of_birth),
      };
      delete transformedValues.date_of_birth; // Remove the old field
      EditPersonalDetails(transformedValues)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            toast.success("Personal Details Updated Successfully");
            resetForm(); // This will clear the form fields

            setRefresh((prev) => !prev);
            setOpen(false);
            // navigate("/make-will-online/about-yourself/partner");
          } else {
            handleApiError(res, navigate);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });
  const validationSchemaForPartner = Yup.object().shape({
    beneficiary_first_name: Yup.string().required("Required field"),
    beneficiary_last_name: Yup.string().required("Required field"),
    beneficiary_email: Yup.string().email("Invalid email address"),
    beneficiary_dob: Yup.string()
      .nullable()
      .matches(
        /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
        "Date of birth must be in dd/mm/yyyy format"
      )
      .test("is-past-date", "Date must be in the past", (value) => {
        if (!value) return true; // Skip if empty
        const [day, month, year] = value.split("/");
        const enteredDate = new Date(`${year}-${month}-${day}`);
        return enteredDate < new Date();
      })
      .test(
        "is-after-1900",
        "Please enter a date of birth after 1900",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          return parseInt(year) > 1900;
        }
      )
      .test(
        "is-over-18",
        "Sorry, but your partner needs to be over 18.",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          const enteredDate = new Date(`${year}-${month}-${day}`);
          const today = new Date();
          const age = today.getFullYear() - enteredDate.getFullYear();
          const isBirthdayPassed =
            today.getMonth() > enteredDate.getMonth() ||
            (today.getMonth() === enteredDate.getMonth() &&
              today.getDate() >= enteredDate.getDate());
          return age > 18 || (age === 18 && isBirthdayPassed);
        }
      ),
  });

  const formikPartner = useFormik({
    initialValues: {
      beneficiary_first_name: yourPartner?.beneficiary_first_name || "",
      beneficiary_last_name: yourPartner?.beneficiary_last_name || "",
      beneficiary_email: yourPartner?.beneficiary_email || "",
      beneficiary_dob: yourPartner?.beneficiary_dob
        ? new Date(yourPartner.beneficiary_dob).toLocaleDateString("en-GB")
        : "",
      is_partner_leave_at_user_location:
        yourPartner?.is_partner_leave_at_user_location,
      beneficiary_location: yourPartner?.beneficiary_location || "",
    },
    validationSchema: validationSchemaForPartner,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      // Convert beneficiary_dob to "yyyy-mm-dd" format
      if (values.beneficiary_dob) {
        const [day, month, year] = values.beneficiary_dob.split("/");
        values.beneficiary_dob = `${year}-${month}-${day}`;
      }
      // Convert `is_partner_leave_at_user_location` to 1 or 0
      values.is_partner_leave_at_user_location =
        values.is_partner_leave_at_user_location ? 1 : 0;

      AddPartner(values)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            resetForm(); // This will clear the form fields
            setRefreshPartner((prev) => !prev);
            setPartnerOpen(false);
            toast.success("Partner added or updated successfully");
          } else {
            handleApiError(res,navigate);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });
  // Yup validation schema
  const validationSchemaForChild = Yup.object().shape({
    beneficiary_first_name: Yup.string().required("Required field"),
    beneficiary_last_name: Yup.string().required("Required field"),
    beneficiary_dob: Yup.string()
      .nullable()
      .matches(
        /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
        "Date of birth must be in dd/mm/yyyy format"
      )
      .required("Required field")
      .test("is-past-date", "Date must be in the past", (value) => {
        if (!value) return true; // Skip if empty
        const [day, month, year] = value.split("/");
        const enteredDate = new Date(`${year}-${month}-${day}`);
        return enteredDate < new Date();
      })
      .test(
        "is-after-1900",
        "Please enter a date of birth after 1900",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          return parseInt(year) > 1900;
        }
      ),
  });
  const formikChild = useFormik({
    initialValues: {
      beneficiary_first_name: "",
      beneficiary_last_name: "",
      beneficiary_dob: "",
    },
    validationSchema: validationSchemaForChild,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      // Convert beneficiary_dob to "yyyy-mm-dd" format
      if (values.beneficiary_dob) {
        const [day, month, year] = values.beneficiary_dob.split("/");
        values.beneficiary_dob = `${year}-${month}-${day}`;
      }

      if (isChildEditMode) {
        // Call the update pet API if in edit mode
        EditChild(values)
          .then((res) => {
            if (res.success && res.status_code === "200") {
              toast.success("Child updated successfully");
              resetForm(); // This will clear the form fields
              setRefreshChild((prev) => !prev);
              setChildOpen(false);
            } else {
              handleApiError(res,navigate);
            }
          })
          .catch((err) => {
            toast.error("An error occurred");
          });
      } else {
        // Call the add Child API if not in edit mode
        AddChild(values)
          .then((res) => {
            if (res.success && res.status_code === "200") {
              toast.success("Child added successfully");
              resetForm(); // This will clear the form fields
              setRefreshChild((prev) => !prev);
              setChildOpen(false);
            } else {
              handleApiError(res,navigate);
            }
          })
          .catch((err) => {
            setLoading(false);
            toast.error("An error occurred");
            console.log(err);
          });
      }
    },
  });
  const petValidationSchema = Yup.object().shape({
    pet_name: Yup.string().required("Required field"),
    pet_type: Yup.string().required("Required field"),
  });
  const petFormik = useFormik({
    initialValues: {
      pet_name: "",
      pet_type: "",
    },
    validationSchema: petValidationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      if (isPetEditMode) {
        // Call the update pet API if in edit mode
        EditPet(values)
          .then((res) => {
            if (res.success && res.status_code === "200") {
              toast.success("Pet updated successfully");
              setRefreshPet((prev) => !prev);
              resetForm();
              setPetOpen(false);
              setIsPetEditMode(false);
            } else {
              handleApiError(res,navigate);
            }
          })
          .catch((err) => {
            console.log(err);
            toast.error("An error occurred");
          });
      } else {
        // Call the add pet API if not in edit mode
        AddPet(values)
          .then((res) => {
            if (res.success && res.status_code === "200") {
              toast.success("Pet added successfully");
              setRefreshPet((prev) => !prev);
              setPetOpen(false);
              resetForm();
            } else {
              handleApiError(res,navigate);
            }
          })
          .catch((err) => {
            console.log(err);
            toast.error("An error occurred");
          });
      }
    },
  });

  // Function to handle edit button click
  const handleEditPet = (petData) => {
    setPetOpen(true);
    setIsPetEditMode(true);
    console.log("petId", petData.id);

    petFormik.setValues({
      pet_name: petData.pet_name,
      pet_type: petData.pet_type,
      pet_id: petData.id,
    });
  };

  const handleEditChild = (childData) => {
    setChildOpen(true);
    setIsChildEditMode(true);
    formikChild.setValues({
      beneficiary_first_name: childData.beneficiary_first_name,
      beneficiary_last_name: childData.beneficiary_last_name,
      beneficiary_dob: formatDate(childData.beneficiary_dob),
      child_id: childData.id,
    });
  };

  return (
    <>
      {contentLoder ? (
        <Loader />
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container">
            <div className="grid grid-cols-2 max-lg:grid-cols-1">
              <div className="mt-[40px]">
                <div>
                  <h4 className="font-bold text-[20px] sm:text-[26px] lg:text-[30px]">
                    Your Family
                  </h4>
                </div>
                <div className="my-5">
                  <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                    <div className="flex items-center justify-between mt-[10px]">
                      <div className="flex gap-2">
                        <div>
                          <img
                            className=""
                            src="/assets/images/document-header.png"
                            alt="mascot-small"
                            style={{
                              height: "45px",
                              width: "45px",
                              borderRadius: "50%",
                            }}
                          />
                        </div>
                        <div>
                          <h4 className="text-[16px] text-black font-bold ">
                            {YourselfData?.first_name} {YourselfData?.last_name}
                          </h4>
                          <p className="text-[15px]">
                            You, the owner of this will
                          </p>
                        </div>
                      </div>
                      <div>
                        <Link>
                          <button
                            onClick={onOpenModal}
                            className="border-2 hover:bg-primary hover:text-white transition-all ease-out rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                          >
                            Edit
                          </button>
                        </Link>
                      </div>
                      <Modal
                        open={open}
                        onClose={onCloseModal}
                        center
                        classNames={{
                          modal:
                            "rounded-[5px] p-5 w-[90%] sm:w-[75%] md:w-[60%] lg:w-[45%] xl:w-[35%] mx-auto", // Adjust modal width for different screen sizes
                        }}
                      >
                        <form onSubmit={formik.handleSubmit} className="px-3">
                          <h2 className="font-bold text-[24px]">
                            Edit yourself
                          </h2>
                          <div>
                            <div className="flex gap-5 mt-[30px]">
                              <div className="w-[30%]">
                                <FloatingLabelDropdown
                                  label="Title"
                                  options={options}
                                  value={formik.values.user_prefix}
                                  onChange={(e) =>
                                    formik.setFieldValue(
                                      "user_prefix",
                                      e.target.value
                                    )
                                  }
                                  name="user_prefix"
                                  error={
                                    formik.touched.user_prefix &&
                                    formik.errors.user_prefix
                                  }
                                />
                              </div>
                              <div className="w-[35%]">
                                <FloatingLabelInput
                                  label="First Name"
                                  type="text"
                                  name="first_name"
                                  value={formik.values.first_name}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched.first_name &&
                                    formik.errors.first_name
                                  }
                                />
                              </div>

                              <div className="w-[35%]">
                                <FloatingLabelInput
                                  label="Last Name"
                                  type="text"
                                  name="last_name"
                                  value={formik.values.last_name}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={
                                    formik.touched.last_name &&
                                    formik.errors.last_name
                                  }
                                />
                              </div>
                            </div>
                            <div className="w-full mt-5">
                              <div className="relative w-full border-2 h-[60px] flex items-center">
                                <MaskedInput
                                  mask={[
                                    /\d/,
                                    /\d/,
                                    "/",
                                    /\d/,
                                    /\d/,
                                    "/",
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                  ]}
                                  placeholder={
                                    isFocused || formik.values.date_of_birth
                                      ? "dd/mm/yyyy"
                                      : ""
                                  }
                                  pipe={autoCorrectedDatePipe}
                                  value={formik.values.date_of_birth}
                                  onFocus={() => setIsFocused(true)}
                                  onBlur={() => setIsFocused(false)}
                                  onChange={(e) =>
                                    formik.setFieldValue(
                                      "date_of_birth",
                                      e.target.value
                                    )
                                  }
                                  className="block text-black  w-full px-[20px] h-full appearance-none focus:outline-none focus:ring-0 peer border-red-500 focus:border-red-500"
                                  name="date_of_birth"
                                />
                                <label
                                  htmlFor="dob"
                                  className="absolute left-5 top-[16px]  text-gray-500 transition-all duration-200 transform text-[10px] -translate-y-3.5 peer-placeholder-shown:text-[16px] peer-placeholder-shown:translate-y-0 peer-focus:text-[10px] peer-focus:-translate-y-3.5"
                                >
                                  Date of birth
                                </label>
                              </div>
                            </div>
                            {formik.touched.date_of_birth &&
                            formik.errors.date_of_birth ? (
                              <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                                <FaInfoCircle />
                                <p className="text-white py-1 px-2 text-sm my-2">
                                  {formik.errors.date_of_birth}
                                </p>
                              </div>
                            ) : null}

                            <div className="mt-5 border-2 border-dashed"></div>
                            <div className="pt-5">
                              <p className="text-[18px] font-bold">
                                What’s your full address?
                              </p>
                              <p className="text-slate-500 text-[16px] py-2">
                                Make sure to enter your full address including
                                your postcode. You can manually type your
                                address if needed.
                              </p>
                              <p className="text-slate-500 text-[16px] py-2">
                                Your full address is required to register your
                                will with the National Will Registry.
                              </p>
                            </div>
                            {!showSecondAddress ? (
                              <div className="first_address">
                                <div className="mt-5 mb-4">
                                  <FloatingLabelInput
                                    label="Search for an address or postcode"
                                    type="text"
                                    id="address_or_postcode"
                                    name="address_or_postcode"
                                    value={""}
                                    // error={errors.address_or_postcode}
                                    onChange={formik.handleChange}
                                    // onChange={(e) => handleChange(e)}
                                  />
                                </div>
                                <button
                                  className="underline"
                                  onClick={() => setShowSecondAddress(true)}
                                >
                                  or add the address manually
                                </button>
                              </div>
                            ) : (
                              <div className="second_address">
                                <div className="mt-5 mb-4">
                                  <FloatingLabelInput
                                    label="Address line 1"
                                    type="text"
                                    id="address_1"
                                    name="address_line_1"
                                    value={formik.values.address_line_1}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={
                                      formik.touched.address_line_1 &&
                                      formik.errors.address_line_1
                                    }
                                  />
                                </div>
                                <div className="mt-5 mb-1">
                                  <FloatingLabelInput
                                    label="Address line 2 (Optional)"
                                    type="text"
                                    id="address_2"
                                    name="address_line_2"
                                    value={formik.values.address_line_2}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                  />
                                </div>
                                <div className="flex items-center gap-5 ">
                                  <div className="mt-5 mb-4 w-[40%]">
                                    <FloatingLabelInput
                                      label="Postcode"
                                      type="text"
                                      id="pincode"
                                      name="postcode"
                                      value={formik.values.postcode}
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      error={
                                        formik.touched.postcode &&
                                        formik.errors.postcode
                                      }
                                    />
                                  </div>
                                  <div className="mt-5 mb-4 w-[60%]">
                                    <FloatingLabelInput
                                      label="City"
                                      type="text"
                                      id="city"
                                      name="city"
                                      value={formik.values.city}
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      error={
                                        formik.touched.city &&
                                        formik.errors.city
                                      }
                                    />
                                  </div>
                                </div>
                                <button
                                  className="underline"
                                  onClick={() => setShowSecondAddress(false)}
                                >
                                  or search by street or postcode
                                </button>
                              </div>
                            )}
                            <div>
                              <div className="py-5 border-b-2 border-dashed">
                                <p className="text-[18px] font-bold">
                                  What is your relationship status?
                                </p>
                                <p className="text-slate-500 text-[16px] py-2">
                                  Enter your current relationship status. For
                                  example, if you are previously divorced and
                                  now with a new partner you would enter “With a
                                  partner, but not married”
                                </p>
                                <div className="my-2">
                                  <FloatingLabelDropdown
                                    label="Select Marrital Status"
                                    options={relationship}
                                    value={formik.values.relationship_id}
                                    onChange={formik.handleChange}
                                    name="relationship_id"
                                    error={
                                      formik.touched.relationship_id &&
                                      formik.errors.relationship_id
                                    }
                                  />
                                </div>
                              </div>
                              <div>
                                <p className="text-slate-500 text-[16px] py-5">
                                  This is optional, and we’ll never call you
                                  unless you ask for help with your will.
                                </p>
                                <div className="mt-1 pb-[30px] border-b-2 ">
                                  <FloatingLabelInput
                                    label="Your Phone Number"
                                    type="text"
                                    id="phone_number"
                                    name="phone_number"
                                    value={formik.values.phone_number}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={
                                      formik.touched.phone_number &&
                                      formik.errors.phone_number
                                    }
                                  />
                                </div>
                              </div>

                              <div className="flex justify-between  my-3">
                                {loading === false ? (
                                  // <Link to={"/your-partner"}>
                                  <button
                                    onClick={() => setShowSecondAddress(true)}
                                    className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded flex items-center gap-1"
                                    type="submit"
                                  >
                                    Update Yourself
                                  </button>
                                ) : (
                                  // </Link>
                                  <button className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded">
                                    <Spinner />
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </form>
                      </Modal>
                    </div>
                  </div>
                </div>
                {Object.keys(yourPartner).length > 0 && (
                  <div className="my-5">
                    <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                      <div className="flex items-center justify-between mt-[10px]">
                        <div className="flex gap-2">
                          <div>
                            <img
                              className=""
                              src="/assets/images/document-header.png"
                              alt="mascot-small"
                              style={{
                                height: "45px",
                                width: "45px",
                                borderRadius: "50%",
                              }}
                            />
                          </div>
                          <div>
                            <h4 className="text-[16px] text-black font-bold ">
                              {yourPartner?.beneficiary_first_name}{" "}
                              {yourPartner?.beneficiary_last_name}
                            </h4>
                            <p className="text-[15px]">Your Partner</p>
                          </div>
                        </div>
                        <div>
                          <Link>
                            <button
                              onClick={() => onPartnerOpenModel(true)}
                              className="border-2 hover:bg-primary hover:text-white transition-all ease-out rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                            >
                              Edit
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {getChild &&
                  getChild.length > 0 &&
                  getChild.map((getChild, index) => (
                    <div key={index} className="my-5">
                      <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4">
                        <div className="flex items-center justify-between mt-[10px]">
                          <div className="flex gap-2">
                            <div>
                              <img
                                src="/assets/images/document-header.png"
                                alt="mascot-small"
                                style={{
                                  height: "45px",
                                  width: "45px",
                                  borderRadius: "50%",
                                }}
                              />
                            </div>
                            <div>
                              <h4 className="text-[16px] text-black font-bold">
                                {getChild?.beneficiary_first_name}{" "}
                                {getChild?.beneficiary_last_name}
                              </h4>
                              <p className="text-[15px]">Your Child</p>
                            </div>
                          </div>
                          <div>
                            <button
                              onClick={() => handleEditChild(getChild)}
                              className="border-2 hover:bg-primary hover:text-white transition-all ease-out rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                            >
                              Edit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                {pet &&
                  pet.length > 0 &&
                  pet.map((pet, index) => (
                    <div key={index} className="my-5">
                      <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4">
                        <div className="flex items-center justify-between mt-[10px]">
                          <div className="flex gap-2">
                            <div>
                              <img
                                src="/assets/images/document-header.png"
                                alt="mascot-small"
                                style={{
                                  height: "45px",
                                  width: "45px",
                                  borderRadius: "50%",
                                }}
                              />
                            </div>
                            <div>
                              <h4 className="text-[16px] text-black font-bold">
                                {pet?.pet_name} {pet?.pet_type}
                              </h4>
                              <p className="text-[15px]">Your Pet</p>
                            </div>
                          </div>
                          <div>
                            <button
                              onClick={() => handleEditPet(pet)}
                              className="border-2 hover:bg-primary hover:text-white transition-all ease-out rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                            >
                              Edit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                <div>
                  <h4 className="font-bold text-[20px] sm:text-[26px] lg:text-[30px]">
                    Add another family member
                  </h4>
                </div>
                {yourPartner.length < 1 && (
                  <div className="my-5">
                    <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                      <div className="flex items-center justify-between mt-[16px]">
                        <div className="flex gap-3">
                          <div>
                            <img
                              src="/assets/images/document-header.png"
                              alt="mascot-small"
                              style={{
                                height: "45px",
                                width: "45px",
                                borderRadius: "50%",
                              }}
                            />
                          </div>
                          <div>
                            <h4 className="text-[16px] text-black font-bold ">
                              Add a partner
                            </h4>
                            <p className="text-[15px]">
                              You can add your partner here
                            </p>
                          </div>
                        </div>

                        <div>
                          <Link>
                            <button
                              onClick={() => onPartnerOpenModel(false)}
                              className="border-2 hover:bg-primary hover:text-white transition-all ease-out rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                            >
                              Add
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="my-5">
                  <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                    <div className="flex items-center justify-between mt-[16px]">
                      <div className="flex gap-3">
                        <div>
                          <img
                            className=""
                            src="/assets/images/document-header.png"
                            alt="mascot-small"
                            style={{
                              height: "45px",
                              width: "45px",
                              borderRadius: "50%",
                            }}
                          />
                        </div>
                        <div>
                          <h4 className="text-[16px] text-black font-bold ">
                            Add a child
                          </h4>
                          <p className="text-[15px]">
                            You can add another child here
                          </p>
                        </div>
                      </div>
                      <div>
                        <Link>
                          <button
                            onClick={() => setChildOpen(true)}
                            className="border-2 hover:bg-primary hover:text-white transition-all ease-out rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                          >
                            Add
                          </button>
                        </Link>
                      </div>
                      <Modal
                        open={childOpen}
                        onClose={onChildCloseModal}
                        classNames={{
                          modal:
                            "rounded-[5px] p-5 w-[95%] sm:w-[80%] md:w-[60%] lg:w-[30%] !m-0", // Adjusting modal width
                        }}
                        center
                      >
                        <form
                          onSubmit={formikChild.handleSubmit}
                          name="FormChild"
                          className="px-5"
                        >
                          <div>
                            {/* Modal Title */}
                            <h2 className="font-bold text-[20px] sm:text-[24px] mb-4">
                              {isChildEditMode ? "Edit Child" : "Add Child"}
                            </h2>

                            {/* Input Fields */}
                            <div className="flex flex-col sm:flex-row items-center gap-5">
                              {/* First Name */}
                              <div className="w-full sm:w-[50%]">
                                <FloatingLabelInput
                                  label="First Name"
                                  type="text"
                                  id="beneficiary_first_name"
                                  value={
                                    formikChild.values.beneficiary_first_name
                                  }
                                  onChange={formikChild.handleChange}
                                  onBlur={formikChild.handleBlur}
                                  error={
                                    formikChild.touched
                                      .beneficiary_first_name &&
                                    formikChild.errors.beneficiary_first_name
                                  }
                                />
                              </div>

                              {/* Last Name */}
                              <div className="w-full sm:w-[50%]">
                                <FloatingLabelInput
                                  label="Last Name"
                                  type="text"
                                  id="beneficiary_last_name"
                                  name="beneficiary_last_name"
                                  value={
                                    formikChild.values.beneficiary_last_name
                                  }
                                  onChange={formikChild.handleChange}
                                  onBlur={formikChild.handleBlur}
                                  error={
                                    formikChild.touched
                                      .beneficiary_last_name &&
                                    formikChild.errors.beneficiary_last_name
                                  }
                                />
                              </div>
                            </div>

                            {/* Date of Birth */}
                            <div className="mt-5">
                              <div className="relative w-full border-2 h-[60px] flex items-center rounded">
                                <MaskedInput
                                  mask={[
                                    /\d/,
                                    /\d/,
                                    "/",
                                    /\d/,
                                    /\d/,
                                    "/",
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                    /\d/,
                                  ]}
                                  placeholder={
                                    isFocused ||
                                    formikChild.values.beneficiary_dob
                                      ? "dd/mm/yyyy"
                                      : ""
                                  }
                                  pipe={autoCorrectedDatePipe}
                                  value={formikChild.values.beneficiary_dob}
                                  onFocus={() => setIsFocused(true)}
                                  onBlur={(e) => {
                                    setIsFocused(false);
                                    formikChild.handleBlur(e);
                                  }}
                                  onChange={(e) =>
                                    formikChild.setFieldValue(
                                      "beneficiary_dob",
                                      e.target.value
                                    )
                                  }
                                  className="block text-black w-full px-5 h-full appearance-none focus:outline-none focus:ring-0 peer rounded border-gray-300 focus:border-gray-500"
                                  name="beneficiary_dob"
                                />
                                <label
                                  htmlFor="dob"
                                  className="absolute left-5 top-[16px] text-gray-500 transition-all duration-200 transform text-[10px] -translate-y-3.5 peer-placeholder-shown:text-[16px] peer-placeholder-shown:translate-y-0 peer-focus:text-[10px] peer-focus:-translate-y-3.5"
                                >
                                  Date of birth
                                </label>
                              </div>
                              {formikChild.touched.beneficiary_dob &&
                              formikChild.errors.beneficiary_dob ? (
                                <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                                  <FaInfoCircle />
                                  <p className="text-white py-1 px-2 text-sm my-2">
                                    {formikChild.errors.beneficiary_dob}
                                  </p>
                                </div>
                              ) : null}
                            </div>
                          </div>

                          {/* Buttons Section */}
                          <div className="flex flex-col sm:flex-row justify-between items-center gap-5 mt-6">
                            {/* Submit Button */}
                            <div className="w-full sm:w-auto">
                              <button
                                type="submit"
                                className="w-full sm:w-auto bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] hover:bg-opacity-90 transition"
                              >
                                {isChildEditMode
                                  ? "Update Child"
                                  : "Add Child"}
                              </button>
                            </div>

                            {/* Remove Button */}
                            {isChildEditMode && (
                              <div className="w-full sm:w-auto">
                                <button
                                  type="button"
                                  onClick={() =>
                                    RemoveChildFunction(
                                      formikChild.values.child_id
                                    )
                                  }
                                  className="w-full sm:w-auto px-5 py-3 text-black border border-gray-600 font-semibold rounded hover:bg-primary hover:text-white transition flex justify-center items-center"
                                >
                                  Remove Child
                                </button>
                              </div>
                            )}
                          </div>
                        </form>
                      </Modal>
                    </div>
                  </div>
                </div>
                <div className="my-5 pb-5">
                  <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                    <div className="flex items-center justify-between mt-[16px]">
                      <div className="flex gap-3">
                        <div>
                          <img
                            className=""
                            src="/assets/images/document-header.png"
                            alt="mascot-small"
                            style={{
                              height: "45px",
                              width: "45px",
                              borderRadius: "50%",
                            }}
                          />
                        </div>
                        <div>
                          <h4 className="text-[16px] text-black font-bold ">
                            Add a Pet
                          </h4>
                          <p className="text-[15px]">You can add a pet here</p>
                        </div>
                      </div>
                      <div>
                        <Link>
                          <button
                            onClick={() => {
                              setPetOpen(true);
                            }}
                            className="border-2 hover:bg-primary hover:text-white transition-all ease-out rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                          >
                            Add
                          </button>
                        </Link>
                      </div>
                      <Modal
                         open={petOpen}
                         onClose={onPetCloseModal}
                        classNames={{
                          modal:
                            "rounded-[5px] p-5 w-[95%] sm:w-[80%] md:w-[60%] lg:w-[30%] !m-0", // Adjusting modal width
                        }}
                        center
                      >
                        <form onSubmit={petFormik.handleSubmit} name="petForm">
                          <div className="px-2">
                            <h2 className="font-bold text-[24px]">
                              {" "}
                              {isPetEditMode ? "Edit Pet" : "Add Pet"}
                            </h2>
                            <input
                              type="hidden"
                              name="pet_id"
                              value={petFormik.values.pet_id}
                            />
                            <div className="mt-[30px]">
                              <div className="">
                                <FloatingLabelInput
                                  label="Your pet's name"
                                  type="text"
                                  id="pet_name"
                                  name="pet_name"
                                  value={petFormik.values.pet_name}
                                  onChange={petFormik.handleChange}
                                  onBlur={petFormik.handleBlur}
                                  error={
                                    petFormik.touched.pet_name &&
                                    petFormik.errors.pet_name
                                  }
                                />
                              </div>
                              <div className="mt-5">
                                <FloatingLabelInput
                                  label="Type of pet"
                                  type="text"
                                  id="pet_type"
                                  name="pet_type"
                                  value={petFormik.values.pet_type}
                                  onChange={petFormik.handleChange}
                                  onBlur={petFormik.handleBlur}
                                  error={
                                    petFormik.touched.pet_type &&
                                    petFormik.errors.pet_type
                                  }
                                />
                              </div>
                              <div className="flex justify-between items-center gap-5">
                                <div className="py-5 ">
                                  <button
                                    type="submit"
                                    className="w-full bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex justify-center items-center gap-2"
                                  >
                                    {isPetEditMode ? "Update Pet" : "Add Pet"}
                                  </button>
                                </div>
                                {isPetEditMode && (
                                  <div className="py-5 ">
                                    <button
                                      type="button"
                                      onClick={() =>
                                        RemovePetFunction(
                                          petFormik.values.pet_id
                                        )
                                      }
                                      className="px-5 py-3 text-black border-solid  border-[1px] border-[#240642] font-semibold border-solid rounded flex items-center gap-1 hover:bg-primary hover:text-white"
                                    >
                                      Remove Pet
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </form>
                      </Modal>
                    </div>
                  </div>
                </div>
                <div className="border-b-2 my-5"></div>
                <div className="flex justify-between pb-5">
                  <Link to={"/make-will-online/about-yourself/pets"}>
                    <button className="flex items-center justify-center font-semiold text-[20px] py-3 rounded-[10px] text-slate-500">
                      <FaAngleLeft />
                      Back
                    </button>
                  </Link>
                  <Link to={"/dashboard"}>
                    <button className="bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-2">
                      OK, that's everyone <FaChevronRight />
                    </button>
                  </Link>
                </div>
              </div>
              <div className="max-lg:hidden bg-no-repeat ">
                <div className="fixed top-[100px] w-[500px] right-[6%]">
                  <img src="/assets/images/11.png" alt="mascot" />
                </div>
              </div>
            </div>
          </div>
          <Modal
            open={partnerOpen}
            onClose={onPartnerCloseModel}
            classNames={{
              modal: "rounded-[5px] p-5", // Add the rounded class here along with padding
            }}
            center
          >
              <form onSubmit={formikPartner.handleSubmit} className="px-5">
                <div>
                  <div>
                    <h4 className="text-[26px] text-black font-bold mt-[10px]">
                      {isEditMode ? "Edit Partner" : "Add Your Partner"}
                    </h4>
                  </div>
                  <div className="grid grid-cols-2 gap-5 ">
                    <div className="mt-5 mb-4 ">
                      <FloatingLabelInput
                        label="First Name"
                        type="text"
                        id="beneficiary_first_name"
                        name="beneficiary_first_name"
                        value={formikPartner.values.beneficiary_first_name}
                        onChange={formikPartner.handleChange}
                        onBlur={formikPartner.handleBlur}
                        error={
                          formikPartner.touched.beneficiary_first_name &&
                          formikPartner.errors.beneficiary_first_name
                        }
                      />
                    </div>

                    <div className="mt-5 mb-4 ">
                      <FloatingLabelInput
                        label="Last Name"
                        type="text"
                        id="beneficiary_last_name"
                        name="beneficiary_last_name"
                        value={formikPartner.values.beneficiary_last_name}
                        onChange={formikPartner.handleChange}
                        onBlur={formikPartner.handleBlur}
                        error={
                          formikPartner.touched.beneficiary_last_name &&
                          formikPartner.errors.beneficiary_last_name
                        }
                      />
                    </div>
                  </div>
                  <div className="mt-1 mb-4 ">
                    <FloatingLabelInput
                      label="Partner's email address (optional)"
                      type="text"
                      id="beneficiary_email"
                      name="beneficiary_email"
                      value={formikPartner.values.beneficiary_email}
                      onChange={formikPartner.handleChange}
                      onBlur={formikPartner.handleBlur}
                      error={
                        formikPartner.touched.beneficiary_email &&
                        formikPartner.errors.beneficiary_email
                      }
                    />
                  </div>
                  <div className="w-full mt-5">
                    <div className="relative w-full border-2 h-[60px] flex items-center">
                      <MaskedInput
                        mask={[
                          /\d/,
                          /\d/,
                          "/",
                          /\d/,
                          /\d/,
                          "/",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                        ]}
                        placeholder={
                          isFocused || formikPartner.values.beneficiary_dob
                            ? "dd/mm/yyyy"
                            : ""
                        }
                        pipe={autoCorrectedDatePipe}
                        value={formikPartner.values.beneficiary_dob}
                        onFocus={() => setIsFocused(true)}
                        onBlur={(e) => {
                          setIsFocused(false);
                          formikPartner.handleBlur(e); // To ensure Formik registers field as "touched"
                        }}
                        onChange={(e) => {
                          formikPartner.setFieldValue(
                            "beneficiary_dob",
                            e.target.value
                          );
                        }}
                        className="block text-black w-full px-[20px] h-full appearance-none focus:outline-none focus:ring-0 peer border-red-500 focus:border-red-500"
                        name="beneficiary_dob"
                      />

                      <label
                        htmlFor="dob"
                        className="absolute left-5 top-[16px]  text-gray-500 transition-all duration-200 transform text-[10px] -translate-y-3.5 peer-placeholder-shown:text-[16px] peer-placeholder-shown:translate-y-0 peer-focus:text-[10px] peer-focus:-translate-y-3.5"
                      >
                        Date of birth(optional)
                      </label>
                    </div>
                  </div>
                  {formikPartner.touched.beneficiary_dob &&
                  formikPartner.errors.beneficiary_dob ? (
                    <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                      <FaInfoCircle />
                      <p className="text-white py-1 px-2 text-sm my-2">
                        {formikPartner.errors.beneficiary_dob}
                      </p>
                    </div>
                  ) : null}

                  <div>
                    <h4 className="text-[16px] text-black font-bold mt-[36px]">
                      Add their address
                    </h4>
                    <p className="text-slate-500 my-2">
                      Adding address is optional
                    </p>
                  </div>
                  <div className="mt-1 mb-4 ">
                    <FloatingLabelInput
                      label="Enter their full address"
                      type="text"
                      id="beneficiary_location"
                      name="beneficiary_location"
                      value={formikPartner.values.beneficiary_location}
                      onChange={formikPartner.handleChange}
                      onBlur={formikPartner.handleBlur}
                    />
                  </div>
                  <div className="mt-5">
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        className="form-checkbox h-5 w-5 text-indigo-600 transition duration-150 ease-in-out"
                        checked={
                          formikPartner.values.is_partner_leave_at_user_location
                        }
                        onChange={() =>
                          formikPartner.setFieldValue(
                            "is_partner_leave_at_user_location",
                            !formikPartner.values
                              .is_partner_leave_at_user_location
                          )
                        }
                      />
                      <span className="ml-2 text-gray-700">
                        They live at my address?
                      </span>
                    </label>
                  </div>
                  <div className="flex justify-between py-5">
                    <div className="mr-5">
                      {!loading ? (
                        <button
                          type="submit"
                          className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded flex items-center gap-1"
                        >
                          {isEditMode ? "Update Partner" : "Add Partner"}
                        </button>
                      ) : (
                        <button className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded">
                          <Spinner />
                        </button>
                      )}
                    </div>
                    {isEditMode && (
                      <div className="">
                        <button
                          type="button"
                          onClick={() => RemovePartnerFunction()}
                          className="px-5 py-3 mt-3 text-black border-solid  border-[1px] border-[#240642] font-semibold border-solid rounded flex items-center gap-1 hover:bg-primary hover:text-white"
                        >
                          Remove Partner
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </form>
          </Modal>
        </>
      )}
    </>
  );
};

export default YourFamilyReview;
